export const state = {
  practices: [],
  availableLanguages: [],
};
